const Events = {
  onFunnelSelect: 'onFunnelSelect',
  onLanguageSelect: 'onLanguageSelect',
};

export default Events;
